<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"   @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import UPDATE from '@/components/page/update.vue'
  import DateUtil from '@/utils/IM/tradeDataUtil'
  import Url from "@/views/crs36/util/url";
  import download from '@/utils/download'
  import Qs from 'qs'
  let type = {"1":"前台报名","2":"人工报名"};
  let activeStatus = {"0":"未激活","1":"已激活"}
  let status = {"1":"待审批","2":"进行中","3":"未开始","4":"已结束"}
  export default {
    name: 'list',
    components: {
      tablePage,
      FORM,
      UPDATE
    },
    methods: {
      /*表格按钮点击事件*/
      bthClick (clickName, row) {
        if (clickName == "update"){
          this.$refs.childUpdate.open(row);
        }else if("delete" == clickName) {
          //审核或启动等操作
          this.dataChanage(Url.experience.user.del, {id: row.id}, res => {
            this.$refs.childTable.defaultGetData(this.queryData);
            if (res.code == 0) {
              this.$refs.childUpdate.close();
              this.$message.success("suc");
            } else {
              this.$message.error(res.message);
            }
          })
        }
      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName){
          this.queryData = data;
          this.$refs.childTable.defaultGetData(this.queryData);
        }else if("新增" == clickName){
          this.$refs.childUpdate.open();
        }else if("导出" == clickName){
          const param = Object.assign(JSON.parse(JSON.stringify(data)), {});
          download.exportExcel(Url.experience.user.download,param,"模拟体验金用户");
        }else if("下载" == clickName){
          const param = Object.assign(JSON.parse(JSON.stringify(data)), {exportHide:true});
          download.exportExcel(Url.experience.user.download,param,"模拟体验金用户");
        }
      },
      /*新增或跟提交数据触发事件*/
      submit(model){
        //根据是否包含id更新还是添加
        this.dataChanage(Url.experience.user.edit,model,res => {
          this.$refs.childTable.defaultGetData(this.queryData);
          if (res.code == 0){
          this.$refs.childUpdate.close();
          this.$message.success("suc");
        }else{
          this.$message.error(res.message);
        }
      })
      },
      dataChanage(url,option,suc,fail){
        this.axios.post(url, Qs.stringify(option || {})).then(res => {

        if(suc && (typeof suc == 'function')) suc(res);
      }).catch(res => {
          if(fail && (typeof fail == 'function')) fail(res);
      })
      }
    },
    data () {
      return {
        queryData:{},
        /*新增或更新*/
        updateData:{
          cols:[
              { title: 'id', field: 'id',hidden:true},
              { title: '真实账号', field: 'realAccount',required:true},
              { title: '模拟账号', field: 'demoAccount',required:true},
              { title: '备注', field: 'remark'},
         ]
        },
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
              { title: '活动id', field: 'taskId',data: this.$route.query.taskId},
              { title: '真实账号', field: 'realAccount'},
              { title: '报名方式', field: 'type',type:2,optionList:type},
              { title: '开始时间', field: 'startTime',type:5},
              { title: '结束时间', field: 'endTime',type:5},
              { title: '激活开始时间', field: 'startActiveTime',type:5},
              { title: '激活结束时间', field: 'endActiveTime',type:5},
              {click:"查询",auth:"crs36:experience:user:find"},
              {click:"下载",auth:"crs36:experience:user:down"},
              {click:"导出",auth:"crs36:experience:user:export"},
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: Url.experience.user.qurey, //请求路径和参数
          selection: true,
          sequence: true,
          cols: [
              { title: '手机区号', field: 'mobilePhonePrefix'},
              { title: '手机号', field: 'mobilePhone'},
              { title: '真实账号', field: 'realAccount'},
              { title: '模拟账号', field: 'demoAccount'},
              { title: '激活时间', field: 'activeTime',render:(data,full)=>{
                  return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                }},
              { title: '报名方式', field: 'type',render:(data,full)=>{
                return type[data];
                }},
              { title: '活动id', field: 'taskId'},
              { title: '活动名称', field: 'taskName'},
              { title: '创建时间', field: 'createTime',render:(data,full)=>{
                return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
              }},
              { title: '开始时间', field: 'startTime',render:(data,full)=>{
                  return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                }},
              { title: '结束时间', field: 'endTime',render:(data,full)=>{
                  return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                }},
              { title: '活动状态', field: 'status',render:(data,full)=>{
                  return status[data];
                }},
              { title: 'ip', field: 'ip'},
              { title: 'ip地址', field: 'ipAddress'},
              { title: '创建者', field: 'creator'},

              { title: '更新者', field: 'updater'},
              { title: '更新时间', field: 'updateTime',render:(data,full)=>{
                  return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                }},
              { title: '备注', field: 'remark'},
              {title: window.$t('crs36.bt.operation'),width: 200,btnClick:[
                {name: window.$t('crs36.bt.edit'),click:"update",type:"primary",icon:"el-icon-edit",auth:"crs36:experience:user:update"},
                {name:"删除",click:"delete",type:"primary",icon: "el-icon-delete",confirm:true,auth:"crs36:experience:user:delete"},
              ]},
          ]
        }
      }
    }
  }
</script>
